import { memo } from "react";
import AboutImg from "../images/AboutUs/about-img.png";
import members from "../images/AboutUs/members-banner.jpg";

function AboutUs({ branch }) {
  // const name = branch?.storeName || "Sibiraja Nagai Maaligai LLP";

  const stats = [
    { value: "40+", label: "Years of Excellence" },
    { value: "50K+", label: "Happy Customers" },
    { value: "100%", label: "Hallmarked Gold" },
    { value: "3", label: "Showrooms" },
  ];

  return (
    <div style={{ background: "#fff" }}>
      {/* Hero */}
      <section
        style={{ padding: "80px 0 60px", background: "var(--surface-warm)" }}
      >
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6">
              <p className="ej-section-eyebrow">Our Story</p>
              <h1
                style={{
                  fontFamily: "var(--font-fam)",
                  fontSize: "clamp(33px,5vw,50px)",
                  fontWeight: 400,
                  color: "var(--ink-900)",
                  lineHeight: 1.15,
                  marginBottom: 20,
                }}
              >
                Crafting Timeless
                <br />
                <em>Jewellery</em> Since 2000
              </h1>
              <p
                style={{
                  fontSize: 14,
                  lineHeight: 1.8,
                  color: "var(--ink-500)",
                  marginBottom: 26,
                }}
              >
                Sibiraja Nagai Maaligai LLP, Since 2000 is one of the most trusted jewellery brand in and around Kangeyam
              </p>
              {/* <p
                style={{
                  fontSize: 15,
                  lineHeight: 1.8,
                  color: "var(--ink-500)",
                  marginBottom: 28,
                }}
              >
                Under the vision of our founder and the able guidance of Mr. A.
                Manojkumar, {name} has transformed into the modern and
                innovative jewellery maker it is today — the destination of
                choice for every occasion.
              </p> */}
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                <a
                  href="/Contact"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "12px 24px",
                    background: "var(--ink-900)",
                    color: "#fff",
                    borderRadius: "var(--radius-pill)",
                    fontSize: 13,
                    fontWeight: 600,
                    textDecoration: "none",
                    letterSpacing: ".05em",
                    transition: "background .14s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "var(--gold-500)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "var(--ink-900)")
                  }
                >
                  Visit Us
                </a>
                <a
                  href="/ProductList"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "12px 24px",
                    background: "transparent",
                    color: "var(--ink-800)",
                    border: "1.5px solid var(--ink-200)",
                    borderRadius: "var(--radius-pill)",
                    fontSize: 13,
                    fontWeight: 600,
                    textDecoration: "none",
                    letterSpacing: ".05em",
                    transition: "border-color .14s,color .14s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = "var(--gold-300)";
                    e.currentTarget.style.color = "var(--gold-500)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = "var(--ink-200)";
                    e.currentTarget.style.color = "var(--ink-800)";
                  }}
                >
                  Browse Collections
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                style={{
                  position: "relative",
                  borderRadius: "var(--radius-xl)",
                  overflow: "hidden",
                  boxShadow: "var(--shadow-lg)",
                }}
              >
                <img
                  src={AboutImg}
                  alt="About Sibiraja Nagai Maaligai LLP"
                  style={{ width: "100%", display: "block" }}
                />
                {/* <div
                  style={{
                    position: "absolute",
                    bottom: 20,
                    left: 20,
                    right: 20,
                    background: "rgba(255,255,255,.92)",
                    borderRadius: "var(--radius-md)",
                    padding: "14px 20px",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: 12,
                      fontWeight: 600,
                      letterSpacing: ".08em",
                      textTransform: "uppercase",
                      color: "var(--gold-500)",
                    }}
                  >
                    Est. 1927
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: 14,
                      fontWeight: 600,
                      color: "var(--ink-900)",
                    }}
                  >
                    Shevapet, Salem — where it all began
                  </p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section
        style={{
          padding: "48px 0",
          borderTop: "1px solid var(--gold-200)",
          borderBottom: "1px solid var(--gold-200)",
          background: "#f6f1fc",
        }}
      >
        <div className="container">
          <div className="row justify-content-center text-center gy-4">
            {stats.map((s, i) => (
              <div key={i} className="col-6 col-md-3">
                <div
                  style={{
                    fontFamily: "var(--font-fam)",
                    fontSize: "clamp(30px,5vw,48px)",
                    fontWeight: 500,
                    color: "var(--gold-400)",
                    lineHeight: 1,
                  }}
                >
                  {s.value}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    letterSpacing: ".08em",
                    textTransform: "uppercase",
                    color: "var(--ink-400)",
                    marginTop: 6,
                  }}
                >
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Retail */}
      {/* <section style={{ padding: "80px 0" }}>
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6">
              <div
                style={{
                  borderRadius: "var(--radius-xl)",
                  overflow: "hidden",
                  boxShadow: "var(--shadow-md)",
                }}
              >
                <img
                  src={retailShop}
                  alt="Retail Showroom"
                  style={{
                    width: "100%",
                    display: "block",
                    objectFit: "cover",
                    maxHeight: 420,
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <p className="ej-section-eyebrow">Our Showrooms</p>
              <h2
                style={{
                  fontFamily: "var(--font-display)",
                  fontSize: "clamp(28px,4vw,40px)",
                  fontWeight: 500,
                  color: "var(--ink-900)",
                  marginBottom: 16,
                }}
              >
                Retail Showroom
              </h2>
              <p
                style={{
                  fontSize: 15,
                  lineHeight: 1.8,
                  color: "var(--ink-500)",
                  marginBottom: 16,
                }}
              >
                Our first retail showroom opened in Gugai in 1996, beginning our
                journey of trust with innumerable customers across Salem. Today,{" "}
                {name} draws inspiration from empowering customers to make
                confident, informed decisions.
              </p>
              <p
                style={{
                  fontSize: 15,
                  lineHeight: 1.8,
                  color: "var(--ink-500)",
                  marginBottom: 24,
                }}
              >
                In 2013 we opened a next-generation luxurious showroom at 4
                Roads, transforming the jewellery experience in the region.
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  padding: "16px",
                  background: "var(--surface-cream)",
                  borderRadius: "var(--radius-md)",
                  border: "1px solid var(--gold-200)",
                }}
              >
                <img
                  src={silks}
                  alt="Eswar Silks"
                  style={{
                    width: 60,
                    height: 60,
                    borderRadius: "var(--radius-sm)",
                    objectFit: "cover",
                    flexShrink: 0,
                  }}
                />
                <p
                  style={{
                    margin: 0,
                    fontSize: 13.5,
                    color: "var(--ink-600)",
                    lineHeight: 1.6,
                  }}
                >
                  In 2004 we expanded with a textile showroom —{" "}
                  <strong>{name} Silks</strong> — further cementing our presence
                  as a complete lifestyle destination.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Members / team */}
      <section style={{ padding: "80px 0", background: "var(--surface-warm)" }}>
        <div className="container">
          <div className="ej-section-head">
            <p className="ej-section-eyebrow">Our People</p>
            <h2 className="ej-section-title">The Team Behind the Craft</h2>
            <p className="ej-section-sub">
              Every piece of jewellery reflects the dedication of our master
              artisans and passionate team.
            </p>
          </div>
          <div
            style={{
              borderRadius: "var(--radius-xl)",
              overflow: "hidden",
              boxShadow: "var(--shadow-md)",
            }}
          >
            <img
              src={members}
              alt="Our Team"
              style={{
                width: "100%",
                display: "block",
                objectFit: "cover",
                maxHeight: 480,
              }}
            />
          </div>
        </div>
      </section>

      {/* Values */}
      <section style={{ padding: "80px 0" }}>
        <div className="container">
          <div className="ej-section-head">
            <p className="ej-section-eyebrow">Why Choose Us</p>
            <h2 className="ej-section-title">Our Commitment to You</h2>
          </div>
          <div className="row gy-4">
            {[
              {
                icon: "🏅",
                title: "BIS Hallmarked",
                desc: "Every piece carries the Bureau of Indian Standards hallmark, guaranteeing purity and authenticity.",
              },
              {
                icon: "🎨",
                title: "Master Craftsmanship",
                desc: "Designed by skilled artisans who bring generations of knowledge and passion to every creation.",
              },
              {
                icon: "💎",
                title: "Premium Selection",
                desc: "From everyday elegance to bridal grandeur — curated collections for every milestone.",
              },
              {
                icon: "🤝",
                title: "Customer Trust",
                desc: "Over four decades of trust, built on transparency, quality, and genuine relationships.",
              },
            ].map((v, i) => (
              <div key={i} className="col-md-6 col-lg-3">
                <div
                  style={{
                    padding: "28px 24px",
                    background: "#fff",
                    border: "1px solid var(--ink-100)",
                    borderRadius: "var(--radius-lg)",
                    height: "100%",
                    transition: "box-shadow .24s,transform .24s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = "var(--shadow-md)";
                    e.currentTarget.style.transform = "translateY(-4px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.transform = "none";
                  }}
                >
                  <div style={{ fontSize: 32, marginBottom: 14 }}>{v.icon}</div>
                  <h5
                    style={{
                      fontFamily: "var(--font-display)",
                      fontSize: 20,
                      fontWeight: 600,
                      color: "var(--ink-900)",
                      marginBottom: 8,
                    }}
                  >
                    {v.title}
                  </h5>
                  <p
                    style={{
                      fontSize: 13.5,
                      color: "var(--ink-400)",
                      lineHeight: 1.7,
                      margin: 0,
                    }}
                  >
                    {v.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default memo(AboutUs);
